'use client'

import { Accordion, Text } from '@vinted/web-ui'

import { useState } from 'react'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { FaqAccordionItemModel } from '@marketplace-web/user-agreements/privacy-center-data'

type Props = {
  faqItem: FaqAccordionItemModel
}

const PrivacyFaqAccordionItem = ({ faqItem }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const translate = useTranslate()

  const handleToggle = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div className="privacy-center__faq-section-accordion">
      <Accordion
        title={translate(faqItem.title)}
        content={<Text as="p" html text={translate(faqItem.description)} />}
        headerId="privacy-center_faq-section-accordion-header"
        bodyId="privacy-center_faq-section-accordion-body"
        isExpanded={isExpanded}
        onToggle={handleToggle}
      />
    </div>
  )
}

export default PrivacyFaqAccordionItem
